export default __webpack_public_path__ + "static/media/logo.ab997503.jpg";